<div [class]="containerClass()" aria-hidden="true">
  <svg
    [style]="iconStyle()"
    [class]="svgClass()"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    @if (!circle()) {
      <g id="check">
        <path
          d="M9,18.25A.74.74,0,0,1,8.47,18l-5-5A.75.75,0,1,1,4.53,12L9,16.44,19.47,6A.75.75,0,0,1,20.53,7l-11,11A.74.74,0,0,1,9,18.25Z"
        />
      </g>
    } @else {
      <g id="check-circle">
        <path
          d="M10.5,15.25A.74.74,0,0,1,10,15L7,12A.75.75,0,0,1,8,11l2.47,2.47L19,5A.75.75,0,0,1,20,6l-9,9A.74.74,0,0,1,10.5,15.25Z"
        />
        <path
          d="M12,21a9,9,0,0,1-7.87-4.66,8.67,8.67,0,0,1-1.07-3.41A9,9,0,0,1,7.66,4.12a8.67,8.67,0,0,1,3.41-1.07,8.86,8.86,0,0,1,3.55.34.75.75,0,1,1-.43,1.43,7.62,7.62,0,0,0-3-.28,7.43,7.43,0,0,0-2.84.89,7.5,7.5,0,0,0-2.2,1.84,7.42,7.42,0,0,0-1.64,5.51,7.43,7.43,0,0,0,.89,2.84,7.5,7.5,0,0,0,1.84,2.2,7.42,7.42,0,0,0,5.51,1.64,7.43,7.43,0,0,0,2.84-.89,7.5,7.5,0,0,0,2.2-1.84,7.42,7.42,0,0,0,1.64-5.51A.75.75,0,1,1,21,11.07a9,9,0,0,1-4.61,8.81A8.67,8.67,0,0,1,12.93,21C12.62,21,12.3,21,12,21Z"
        />
      </g>
    }
  </svg>
</div>
